import { getTrackingService } from '@gig/magic-common';
import { EXPERIMENT_QUERY, EXPERIMENT_QUERY_ACTIVE_VARIANT, EXPERIMENT_QUERY_VARIANT_ENABLED } from '@gig/magic-messages';

const EXPERIMENTS_KEY = "wand-experiments-";
class ExperimentService {
  constructor(experimentsConfig) {
    this.experiments = {};
    this.runningExperiments = {};
    this.accessedExperiments = new Set();
    this.registerExperimentsQueries();
    if (experimentsConfig) {
      this.initializeExperiments(experimentsConfig);
    }
  }
  registerExperimentsQueries() {
    window.queryBus.subscribe(EXPERIMENT_QUERY, () => {
      return this.experiments;
    });
    window.queryBus.subscribe(EXPERIMENT_QUERY_ACTIVE_VARIANT, (name) => {
      if (!name.payload) {
        return;
      }
      return this.getActiveVariant(name.payload);
    });
    window.queryBus.subscribe(EXPERIMENT_QUERY_VARIANT_ENABLED, (name) => {
      if (!name.payload) {
        return;
      }
      return this.enabledVariant(name.payload);
    });
  }
  initializeExperiments(experimentsConfig) {
    this.experiments = experimentsConfig;
    this.runningExperiments = {};
    Object.keys(this.experiments).forEach((experimentKey) => {
      const experiment = this.experiments[experimentKey];
      const variantName = this.getCurrentStoredVariant(experimentKey);
      const variant = experiment.variants.find(({ name }) => name === variantName);
      if (variantName && variant) {
        this.runningExperiments[experiment.name] = variant;
      } else {
        const chosenVariant = this.getRandomVariant(experiment.variants);
        this.setRunningExperiment(experiment.name, chosenVariant);
      }
    });
  }
  getExperiment(name) {
    return this.experiments[name] || false;
  }
  getActiveVariant(name) {
    const config = this.getExperiment(name);
    if (!config) {
      return false;
    }
    const variant = this.runningExperiments[name];
    if (!variant) {
      return false;
    }
    this.trackExperiment(config, variant);
    return variant;
  }
  enabledVariant(name) {
    const activeExperiment = this.getActiveVariant(name);
    if (!activeExperiment) {
      return false;
    }
    return !!activeExperiment.name;
  }
  trackExperiment(config, variant) {
    this.accessedExperiments.add(`${config.id}.${variant.id}`);
    getTrackingService().setExperiments(Array.from(this.accessedExperiments).join("!"));
  }
  getRandomVariant(variants) {
    const length = variants.length;
    const index = Math.floor(Math.random() * length);
    return variants[index];
  }
  setRunningExperiment(name, variant) {
    this.runningExperiments[name] = variant;
    try {
      localStorage.setItem(this.getExperimentKey(name), variant.name);
    } catch (e) {
    }
  }
  getExperimentKey(name) {
    return `${EXPERIMENTS_KEY}${name}`;
  }
  getCurrentStoredVariant(name) {
    try {
      const storageKey = this.getExperimentKey(name);
      return localStorage.getItem(storageKey) || false;
    } catch (e) {
      return false;
    }
  }
}

export { ExperimentService };
